import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { IndustryPain } from './components/IndustryPain';
import { WhatWeBuild } from './components/WhatWeBuild';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-midnight-deep" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <IndustryPain data-id="element-4" />
        <WhatWeBuild data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Pricing data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}